import React from "react";
import "./SearchBox.css";

const SearchBox = ({ onSearch, value }) => {
  function handleSearchInputChange(event) {
    onSearch(event.target.value);
  }

  function handleClearClick(event) {
    event.preventDefault();
    onSearch("");
  }

  function handleSubmit(event) {
    event.preventDefault();
  }

  return (
    <div className="search-box-wrapper">
      <div className="search-container">
        <form onSubmit={handleSubmit}>
          <input
            type="text"
            className="search-input"
            value={value}
            onChange={handleSearchInputChange}
            placeholder="Search titles, topics, or sources..."
          />
          <i className="search-icon">🔍</i>
          <button className="clear-button" onClick={handleClearClick}>
            Clear
          </button>
        </form>
      </div>
    </div>
  );
};

export default SearchBox;
